import axios from "axios";
import {ApiCustomerConfigurationInterface} from "../redux/customer_configuration/customer_configuration.type";


async function getCustomerConfiguration(uuid: string){
    return axios({
        method: "GET",
        url: `/api/v1/workspaces/${uuid}/configuration`
    })
}

async function postCustomerConfiguration(uuid: string, data: ApiCustomerConfigurationInterface ) {
    return axios({
        method: "POST",
        url: `/api/v1/workspaces/${uuid}/configuration`,
        data
    });
}

async function patchCustomerConfiguration(uuid: string, configUuid: string, data: ApiCustomerConfigurationInterface ){
    return axios({
        method: "PATCH",
        url: `/api/v1/workspaces/${uuid}/configuration/${configUuid}`,
        data
    })
}

export {
    getCustomerConfiguration,
    patchCustomerConfiguration,
    postCustomerConfiguration
}
